import { useEffect, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import QRCodeStyling from 'qr-code-styling';

const QRCodeWithLabelAndLogo = ({ value, label }) => {
    const printRef = useRef(null);
    const qrRef = useRef(null);
    const qrCodeRef = useRef(null);
    const reactToPrintFn = useReactToPrint({ contentRef: printRef });

    useEffect(() => {
        if (!qrRef.current || !value) return;

        const qrContainer = qrRef.current;

        // Initialize QRCodeStyling instance
        qrCodeRef.current = new QRCodeStyling({
            width: 240,
            height: 240,
            type: 'svg',
            data: value,
            image: require('../../assets/images/greensense-logo-leaf-black.png'),
            margin: 10,
            qrOptions: {
                typeNumber: 0,
                mode: 'Byte',
                errorCorrectionLevel: 'H',
            },
            dotsOptions: {
                type: 'rounded',
                gradient: {
                    type: 'radial',
                    rotation: 0.8,
                    colorStops: [
                        // { offset: 0, color: '#00c853' },
                        { offset: 0, color: '#000000' },
                        { offset: 1, color: '#000000' },
                    ],
                },
            },
            cornersSquareOptions: {
                type: 'extra-rounded',
                // color: '#8dc791ff',
                color: '#000000',
            },
            cornersDotOptions: {
                type: 'dot',
                color: '#000000',
            },
            backgroundOptions: {
                color: '#ffffff',
            },
            imageOptions: {
                crossOrigin: 'anonymous',
                margin: 4,
                imageSize: 0.4,
                hideBackgroundDots: true,
            },
        });

        // Append QR code to the DOM
        qrCodeRef.current.append(qrContainer);

        // Cleanup
        return () => {
            if (qrContainer) {
        qrContainer.innerHTML = '';
      }
        };
    }, [value]);

    return (
        <div>
            {/* Printable Section */}
            <div ref={printRef} style={{ padding: '20px', backgroundColor: 'white' }}>
                <div
                    style={{
                        borderRadius: '14px',
                        border: '4px solid #007b4e',
                        padding: '20px',
                        display: 'inline-block',
                        textAlign: 'center',
                        backgroundColor: 'white',
                    }}
                >
                    {label && (
                        <div style={{ marginTop: '12px', fontSize: '20px', fontWeight: 'bold' }}>
                            {label}
                        </div>
                    )}
                    <div style={{ width: 240, height: 240 }}>
                        <div ref={qrRef} style={{ width: '240px', height: '240px' }} />
                    </div>
                    <div style={{ marginTop: '12px', fontSize: '18px', fontWeight: 'bold' }}>
                        Greenwaveinnovations.ca
                    </div>
                </div>
            </div>

            {/* Print Button */}
            <div className="px-5">
                <button
                    className="text-[12px] px-[75px] py-1 border border-1 rounded-md"
                    onClick={reactToPrintFn}
                >
                    Print QR Code
                </button>
            </div>
        </div>
    );
};

export default QRCodeWithLabelAndLogo;